<template>
  <div class="CustomerList">
    <div
      class="item acea-row row-between-wrapper"
      v-for="(item, index) in list"
      :key="index"
      @click="goList(index)"
    >
      <!-- $router.push('/customer/chat/' + item.uid + '&productId=' + productId) -->
      <div class="pictrue" style="position: relative;">
        <img :src="item.avatar" />
        <div
          v-if="item.new_msg"
          style="width:1em;height:1em;border-radius: 100%;background:red;color:#fff;position: absolute;text-align: center;top:0;right:0;display: block;line-height:1em"
        >
          {{ item.new_msg }}
        </div>
      </div>
      <div class="text line1">{{ item.nickname }}</div>
    </div>
    <div class="footer-line-height"></div>
  </div>
</template>
<script>
import { serviceList } from "@api/user";

export default {
  name: "CustomerList",
  data() {
    return {
      list: [],
      productId: ""
    };
  },
  methods: {
    getList(mid) {
      serviceList(mid).then(res => {
        this.list = res.data;
      });
    },
    goList(index) {
      this.$router.push({
        path: "/customer/chat/" + this.list[index].uid,
        query: { productId: this.productId }
      });
      // $router.push('/customer/chat/' + item.uid + '&productId=' + productId)
    }
  },
  mounted() {
    this.getList(this.$route.query.mid);
    this.productId = this.$route.query.productId;
    console.log(this.productId);
  }
};
</script>
<style scoped>
.footer-line-height {
  height: 1rem;
}
.CustomerList {
  margin-top: 0.13rem;
}
.CustomerList .item {
  height: 1.38rem;
  border-bottom: 1px solid #eee;
  padding: 0 0.24rem;
  background-color: #fff;
}
.CustomerList .item .pictrue {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 50%;
  border: 0.03rem solid #fff;
  box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -webkit-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -moz-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
}
.CustomerList .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.CustomerList .item .text {
  width: 5.82rem;
  font-size: 0.32rem;
  color: #000;
}
</style>
